import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__tanstack_react_table_777e1b4b__ from "@tanstack/react-table";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__ from "./button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__ from "./input.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_6aa0b418__ from "./dropdown-menu.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__ from "./select.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__ from "./table.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__ from "./popover.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__ from "./command.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__badge_mjs_dd14f332__ from "./badge.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__separator_mjs_369599fa__ from "./separator.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
function DataTable({ columns, data, disablePagination = false, tableRef }) {
    var _table_getRowModel_rows;
    const [sorting, setSorting] = __WEBPACK_EXTERNAL_MODULE_react__.useState([]);
    const [columnFilters, setColumnFilters] = __WEBPACK_EXTERNAL_MODULE_react__.useState([]);
    const [columnVisibility, setColumnVisibility] = __WEBPACK_EXTERNAL_MODULE_react__.useState({});
    const [rowSelection, setRowSelection] = __WEBPACK_EXTERNAL_MODULE_react__.useState({});
    const [pageIndex, setPageIndex] = __WEBPACK_EXTERNAL_MODULE_react__.useState(0);
    const [pageSize, setPageSize] = __WEBPACK_EXTERNAL_MODULE_react__.useState(10);
    const table = (0, __WEBPACK_EXTERNAL_MODULE__tanstack_react_table_777e1b4b__.useReactTable)({
        data,
        columns,
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,
        getCoreRowModel: (0, __WEBPACK_EXTERNAL_MODULE__tanstack_react_table_777e1b4b__.getCoreRowModel)(),
        getPaginationRowModel: (0, __WEBPACK_EXTERNAL_MODULE__tanstack_react_table_777e1b4b__.getPaginationRowModel)(),
        getSortedRowModel: (0, __WEBPACK_EXTERNAL_MODULE__tanstack_react_table_777e1b4b__.getSortedRowModel)(),
        getFilteredRowModel: (0, __WEBPACK_EXTERNAL_MODULE__tanstack_react_table_777e1b4b__.getFilteredRowModel)(),
        onColumnVisibilityChange: setColumnVisibility,
        onRowSelectionChange: setRowSelection,
        onPaginationChange: (updater)=>{
            const newState = "function" == typeof updater ? updater(table.getState().pagination) : updater;
            setPageIndex(newState.pageIndex);
            setPageSize(newState.pageSize);
        },
        filterFns: {
            fuzzy: (row, columnId, value)=>{
                const itemValue = String(row.getValue(columnId)).toLowerCase();
                const filterValue = String(value).toLowerCase();
                return itemValue.includes(filterValue);
            }
        },
        state: {
            sorting,
            columnFilters,
            columnVisibility,
            rowSelection,
            pagination: {
                pageIndex,
                pageSize
            }
        },
        enableRowSelection: true,
        enableMultiRowSelection: true,
        debugTable: true,
        debugHeaders: true,
        debugColumns: true
    });
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (tableRef) tableRef.current = table;
    }, [
        table,
        tableRef
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: "tw-w-full",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "tw-rounded-t-md tw-border tw-bg-white",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.Table, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.TableHeader, {
                            className: "!tw-bg-neutral-100 !tw-text-neutral-800",
                            children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.TableRow, {
                                    children: headerGroup.headers.map((header)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.TableHead, {
                                            className: "!tw-text-neutral-800 !tw-bg-neutral-100",
                                            children: header.isPlaceholder ? null : (0, __WEBPACK_EXTERNAL_MODULE__tanstack_react_table_777e1b4b__.flexRender)(header.column.columnDef.header, header.getContext())
                                        }, header.id))
                                }, headerGroup.id))
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.TableBody, {
                            children: (null === (_table_getRowModel_rows = table.getRowModel().rows) || void 0 === _table_getRowModel_rows ? void 0 : _table_getRowModel_rows.length) ? table.getRowModel().rows.map((row)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.TableRow, {
                                    "data-state": row.getIsSelected() && "selected",
                                    children: row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.TableCell, {
                                            className: "tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis",
                                            children: (0, __WEBPACK_EXTERNAL_MODULE__tanstack_react_table_777e1b4b__.flexRender)(cell.column.columnDef.cell, cell.getContext())
                                        }, cell.id))
                                }, row.id)) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.TableRow, {
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__table_mjs_255f09ec__.TableCell, {
                                    colSpan: table.getAllColumns().length,
                                    className: "tw-h-24 tw-text-center",
                                    children: "No results."
                                })
                            })
                        })
                    ]
                })
            }),
            !disablePagination && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DataTablePagination, {
                table: table
            })
        ]
    });
}
function DataTablePagination({ table, className = "" }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: `tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-4 tw-bg-white tw-border-t-0 tw-border tw-rounded-b-md ${className}`,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "tw-flex-1 tw-text-sm tw-text-muted-foreground",
                children: [
                    table.getFilteredSelectedRowModel().rows.length,
                    " of",
                    " ",
                    table.getFilteredRowModel().rows.length,
                    " row(s) selected."
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "tw-flex tw-items-center tw-gap-6 lg:tw-gap-8",
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
                                className: "tw-text-sm tw-font-medium tw-mr-2",
                                children: "Rows per page"
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.Select, {
                                value: `${table.getState().pagination.pageSize}`,
                                onValueChange: (value)=>{
                                    const size = Number(value);
                                    table.setPageSize(size);
                                },
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.SelectTrigger, {
                                        className: "tw-h-8 tw-w-[70px]",
                                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.SelectValue, {
                                            placeholder: table.getState().pagination.pageSize
                                        })
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.SelectContent, {
                                        side: "top",
                                        children: [
                                            10,
                                            20,
                                            30,
                                            40,
                                            50
                                        ].map((pageSize)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__select_mjs_b75cb376__.SelectItem, {
                                                value: `${pageSize}`,
                                                children: pageSize
                                            }, pageSize))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-medium tw-whitespace-nowrap",
                        children: [
                            "Page ",
                            table.getState().pagination.pageIndex + 1,
                            " of",
                            " ",
                            table.getPageCount()
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "tw-flex tw-items-center tw-gap-1",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                variant: "outline",
                                onClick: ()=>table.setPageIndex(0),
                                disabled: !table.getCanPreviousPage(),
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                        className: "tw-sr-only",
                                        children: "Go to first page"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronsLeft, {
                                        className: "tw-h-4 tw-w-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                variant: "outline",
                                onClick: ()=>table.previousPage(),
                                disabled: !table.getCanPreviousPage(),
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                        className: "tw-sr-only",
                                        children: "Go to previous page"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronLeft, {
                                        className: "tw-h-4 tw-w-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                variant: "outline",
                                onClick: ()=>table.nextPage(),
                                disabled: !table.getCanNextPage(),
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                        className: "tw-sr-only",
                                        children: "Go to next page"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronRight, {
                                        className: "tw-h-4 tw-w-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                                variant: "outline",
                                onClick: ()=>table.setPageIndex(table.getPageCount() - 1),
                                disabled: !table.getCanNextPage(),
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                        className: "tw-sr-only",
                                        children: "Go to last page"
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronsRight, {
                                        className: "tw-h-4 tw-w-4"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function DataTableSimplePagination({ table, showingText = true, className = "", connected = false }) {
    const { pageSize, pageIndex } = table.getState().pagination;
    const totalRows = table.getFilteredRowModel().rows.length;
    const pageCount = table.getPageCount();
    const startRow = pageIndex * pageSize + 1;
    const endRow = Math.min((pageIndex + 1) * pageSize, totalRows);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: `
      tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-between
      tw-px-2 tw-py-4 tw-bg-white tw-border
      ${connected ? "tw-border-t-0 tw-rounded-b-md" : "tw-rounded-md tw-mt-2"}
      ${className}
    `,
        children: [
            showingText && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "tw-mb-2 md:tw-mb-0 tw-text-sm",
                children: [
                    "Showing ",
                    startRow,
                    " to ",
                    endRow,
                    " of ",
                    totalRows
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "tw-flex tw-items-center tw-space-x-6",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-space-x-2",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                            className: "tw-text-sm",
                            children: [
                                "Page ",
                                pageIndex + 1,
                                " of ",
                                pageCount
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                            variant: "outline",
                            size: "sm",
                            onClick: ()=>table.previousPage(),
                            disabled: !table.getCanPreviousPage(),
                            children: "Previous"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                            variant: "outline",
                            size: "sm",
                            onClick: ()=>table.nextPage(),
                            disabled: !table.getCanNextPage(),
                            children: "Next"
                        })
                    ]
                })
            })
        ]
    });
}
function DataTableColumnVisibility({ table }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_6aa0b418__.DropdownMenu, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_6aa0b418__.DropdownMenuTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                    variant: "outline",
                    className: "tw-ml-auto",
                    children: [
                        "Columns ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronDown, {
                            className: "tw-ml-2 tw-h-4 tw-w-4"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_6aa0b418__.DropdownMenuContent, {
                align: "end",
                children: table.getAllColumns().filter((column)=>column.getCanHide()).map((column)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dropdown_menu_mjs_6aa0b418__.DropdownMenuCheckboxItem, {
                        className: "tw-capitalize",
                        checked: column.getIsVisible(),
                        onCheckedChange: (value)=>column.toggleVisibility(!!value),
                        children: column.id
                    }, column.id))
            })
        ]
    });
}
function DataTableSearch({ table, columnId, placeholder = "Search...", className = "" }) {
    const column = table.getColumn(columnId);
    if (!column) return null;
    const value = column.getFilterValue();
    const columnFilterValue = "string" == typeof value ? value : "";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: `tw-flex tw-items-center tw-gap-2 ${className}`,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__input_mjs_9e13df5e__.Input, {
                placeholder: placeholder,
                value: columnFilterValue,
                onChange: (e)=>{
                    column.setFilterValue(e.target.value);
                },
                className: "tw-max-w-sm"
            }),
            columnFilterValue && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                variant: "ghost",
                onClick: ()=>{
                    column.setFilterValue("");
                },
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.X, {
                    className: "tw-h-4 tw-w-4"
                })
            })
        ]
    });
}
function SortableColumnHeader({ column, title }) {
    if (!column.getCanSort()) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        children: title
    });
    const sortStatus = column.getIsSorted();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
        variant: "ghost",
        onClick: ()=>{
            if (sortStatus) {
                if ("asc" === sortStatus) column.toggleSorting(true);
                else column.clearSorting();
            } else column.toggleSorting(false);
        },
        className: "tw-gap-1 tw-pl-0",
        children: [
            title,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                className: "tw-ml-1",
                children: [
                    !sortStatus && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronsUpDown, {
                        className: "tw-h-4 tw-w-4"
                    }),
                    "asc" === sortStatus && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronUp, {
                        className: "tw-h-4 tw-w-4"
                    }),
                    "desc" === sortStatus && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.ChevronDown, {
                        className: "tw-h-4 tw-w-4"
                    })
                ]
            })
        ]
    });
}
function DataTableFacetedFilter({ column, title, options }) {
    const facets = null == column ? void 0 : column.getFacetedUniqueValues();
    const selectedValues = new Set(null == column ? void 0 : column.getFilterValue());
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.Popover, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverTrigger, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                    variant: "outline",
                    className: "tw-border-dashed",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.PlusCircle, {
                            className: "tw-mr-2 tw-h-4 tw-w-4"
                        }),
                        title,
                        (null == selectedValues ? void 0 : selectedValues.size) > 0 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__separator_mjs_369599fa__.Separator, {
                                    orientation: "vertical",
                                    className: "tw-mx-2 tw-h-4"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__badge_mjs_dd14f332__.Badge, {
                                    variant: "secondary",
                                    className: "tw-rounded-sm tw-px-1 tw-font-normal lg:tw-hidden",
                                    children: selectedValues.size
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                    className: "tw-hidden tw-space-x-1 lg:tw-flex",
                                    children: selectedValues.size > 2 ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__badge_mjs_dd14f332__.Badge, {
                                        variant: "secondary",
                                        className: "tw-rounded-sm tw-px-1 tw-font-normal",
                                        children: [
                                            selectedValues.size,
                                            " selected"
                                        ]
                                    }) : options.filter((option)=>selectedValues.has(option.value)).map((option)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__badge_mjs_dd14f332__.Badge, {
                                            variant: "secondary",
                                            className: "tw-rounded-sm tw-px-1 tw-font-normal",
                                            children: option.label
                                        }, option.value))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__popover_mjs_66cb72c6__.PopoverContent, {
                align: "start",
                className: "tw-p-0 tw-w-auto",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.Command, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandInput, {
                            placeholder: title
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandList, {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandEmpty, {
                                    children: "No results found."
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandGroup, {
                                    children: options.map((option)=>{
                                        const isSelected = selectedValues.has(option.value);
                                        return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandItem, {
                                            onSelect: ()=>{
                                                if (isSelected) selectedValues.delete(option.value);
                                                else selectedValues.add(option.value);
                                                const filterValues = Array.from(selectedValues);
                                                null == column || column.setFilterValue(filterValues.length ? filterValues : void 0);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-mr-2 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-sm tw-border tw-border-primary", isSelected ? "tw-bg-primary tw-text-primary-foreground" : "tw-opacity-50 [&_svg]:tw-invisible"),
                                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Check, {})
                                                }),
                                                option.icon && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(option.icon, {
                                                    className: "tw-mr-2 tw-h-4 tw-w-4 tw-text-muted-foreground"
                                                }),
                                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                                    children: option.label
                                                }),
                                                (null == facets ? void 0 : facets.get(option.value)) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                                    className: "tw-ml-auto tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-font-mono tw-text-xs",
                                                    children: facets.get(option.value)
                                                })
                                            ]
                                        }, option.value);
                                    })
                                }),
                                selectedValues.size > 0 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandSeparator, {}),
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandGroup, {
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__command_mjs_686640ff__.CommandItem, {
                                                onSelect: ()=>null == column ? void 0 : column.setFilterValue(void 0),
                                                className: "tw-justify-center tw-text-center",
                                                children: "Clear filters"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
export { DataTable, DataTableColumnVisibility, DataTableFacetedFilter, DataTablePagination, DataTableSearch, DataTableSimplePagination, SortableColumnHeader };

//# sourceMappingURL=data-table.mjs.map